export default __webpack_public_path__ + "static/media_hero@2x-f2ddcf6bb98464a1179e4a38f3d0465c.jpg";